import { Vector3 } from "three";
import { Context } from "../../context";
import {
  CameraLandmark,
  CameraLandmarkLookup,
  CameraMode,
  SmoothTimes,
} from "../controller";
import { CameraModeOptions, ControllerStrategy } from "../strategy/strategy";

export class InitControllerStrategy extends ControllerStrategy {
  private contextRef?: Context;
  private targetMode?: CameraMode;
  private triggerDistance = 15;

  init(context: Context, options: CameraModeOptions): ControllerStrategy {
    if (!this.registered || !this.registered.controls) {
      console.error("init mode called without controller");
      return this;
    }

    this.contextRef = context;

    if (!options.initData) {
      console.warn(
        "init mode called without initData, defaulting to strikezone"
      );
      options.initData = {
        mode: CameraMode.STRIKEZONE,
        landmark: CameraLandmark.STRIKEZONE_CENTER_BACK,
      };
    }

    this.targetMode = options.initData.mode;

    if (context.options.cameraIntro) {
      this.registered.controls.smoothTime = SmoothTimes.MEDIUM_SLOW;
      this.registered.controls.enabled = false;
      this.registered.setMode(CameraMode.MAP, { fromManager: true });
      this.registered.setLocation(options.initData.landmark, (pos: Vector3) => {
        if (!this.registered?.controls || !options.initData) return false;
        const dist = pos.distanceTo(
          CameraLandmarkLookup[options.initData.landmark]
        );
        if (dist < this.triggerDistance) {
          // this will trigger teardown of INIT
          this.registered.setMode(options.initData.mode, {
            fromInteraction: true,
          });
          return true;
        }
        return false;
      });
    } else {
      // skip into and immediately set subsequent mode
      this.registered.setLocation(options.initData.landmark, undefined, false);
      // this will trigger teardown of INIT
      this.registered.setMode(options.initData.mode, { fromInteraction: true });
    }

    return this;
  }

  update(
    _deltaS: number,
    _gameTimeDelta: number,
    _frameNum?: number | undefined
  ): void {
    // hide players if we're going into strikezone
    // TODO: improve this code duplication
    if (this.targetMode === CameraMode.STRIKEZONE) {
      let actors = this.contextRef?.world?.actors.getActors();
      if (actors) {
        for (let actor of actors) {
          actor.hideBehindPlate();
        }
      }
    }
  }

  teardown(): void {
    if (!this.registered?.controls) return;

    this.registered.controls.enabled = true;
  }
}
